import React from 'react';
import { Button } from 'semantic-ui-react';

import ButtonWrapper from './ButtonWrapper';
import { VIEW_MODE } from '../../constants';

class CurrentRemoveUserTagButtonsWrapper extends React.PureComponent {
  render() {
    const { disabled, mode, setDefaultUser, id } = this.props;
    return mode !== VIEW_MODE ? (
      <Button.Group className="mini">
        <ButtonWrapper
          id={id + 'DefaultUser'}
          type="button"
          icon="user"
          primary={true}
          className="inputDefaultButton"
          onClick={() => setDefaultUser(false)}
          disabled={disabled}
        />
        <ButtonWrapper
          icon="remove"
          color="red"
          className="inputDefaultButton"
          onClick={() => setDefaultUser(true)}
          disabled={disabled}
        />
      </Button.Group>
    ) : null;
  }
}

export default CurrentRemoveUserTagButtonsWrapper;
